export default {"src":"https://webcdn.trailways.com/_next/static/media/success-circle.5aa52758.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};